export default __webpack_public_path__ + "static/media/btn-secondary.f072b8f6.png";